import { instance } from './config';

export const getFloatAccounts = () => {
   return instance.get('/float');
};

export const createFloatAccount = (data) => {
   return instance.post('/float', data);
};

export const updateFloatAccount = (data) => {
   return instance.put('/float', data);
};
